module.exports = __webpack_public_path__ + "static/media/ImgWord.0b242b4e.svg";